import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { configureIonicons } from './app/ionicons.setup';
import { environment } from './environments/environment';
import { installDeviceOnlineCorrection } from './app/services/network-status/device-online';

installDeviceOnlineCorrection();

if (environment.production) {
  enableProdMode();
}

// Load Sentry off the critical path (separate chunk); start in parallel with bootstrap.
const sentryReady = environment.production
  ? import('./sentry-init').then((m) => {
      m.initSentry();
      return m;
    })
  : null;

configureIonicons();

platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(async (err: unknown) => {
    console.error('[Bootstrap Error] Angular module failed to bootstrap:', err);
    try {
      const sentry = await sentryReady;
      sentry?.reportBootstrapFailure(err);
    } catch {
      // Sentry load/report must not hide the original bootstrap failure.
    }
    throw err;
  });
